module.exports = __webpack_public_path__ + "static/img/slide_1.6f5fbf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/slide_1.png
// module id = +G49
// module chunks = 0